import { Theme } from "@mui/material/styles";
import colors from "assets/theme/base/colors";

const { text, white, background } = colors;

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  bodyContainer: {
    position: "absolute",
    bottom: 0,
    width: theme.width.full,
    height: "calc(100dvh - 240px)",
    background: `${white.main}!important`,
    color: text.main,
    borderTopLeftRadius: "28px",
    borderTopRightRadius: "28px",
    padding: "20px",
    overflow: "hidden",
  },
  step_MODALS: {
    background: `${background.primary}!important`,
    bottom: 0,
    width: theme.width.full,
    height: "calc(100dvh - 120px)",
    borderRadius: 0,
  },
});
